import React from "react";
import showIcon from "../../../../../assets/design-revamp-company/company-detail-headers/icon-show-table.svg";
import hideIcon from "../../../../../assets/design-revamp-company/company-detail-headers/icon-hide-table.svg";
import { usePDFShowHide } from "../../../../../hooks/usePDFShowHide";

export const ShowHide = ({ show: externalShow, setShow: externalSetShow }) => {
  const [internalShow, setInternalShow, isPDFMode] = usePDFShowHide(false, {
    forceShowInPDF: true, // This will force show to be true in PDF mode
  });

  // Use external state if provided, otherwise use internal state
  const show = externalShow !== undefined ? externalShow : internalShow;
  const setShow = externalSetShow || setInternalShow;

  // In PDF mode, the usePDFShowHide hook will handle forcing show to true
  // No need for additional logic here

  return (
    <img
      src={show ? hideIcon : showIcon}
      alt={show ? "Hide Icon" : "Show Icon"}
      width={40}
      height={40}
      onClick={() => !isPDFMode && setShow(!show)}
      className="show-hide-icon"
      style={{
        opacity: isPDFMode ? 0.5 : 1,
        cursor: isPDFMode ? "default" : "pointer",
      }}
    />
  );
};
